interface LoginModalScope extends ng.IScope {
	fields: {
		Email: string;
		Password: string;
		Remember: string;
	};
	error?: {
		Message: string;
		MessageType: string;
	}
	pending: boolean;
	submitLogin(ev: any);
	$close(result: any);
	$dismiss(reason: any);
}

export class LoginModalCtrl {
	public static $inject = ['$scope', '$http'];

	constructor($scope: LoginModalScope, $http: ng.IHttpService) {
		$scope.pending = false;

		$scope['submitLogin'] = (ev) => {
			console.log('submitLogin');
			console.log(ev);

			console.log($scope.fields);

			if ($scope.pending) {
				return;
			}

			$scope.pending = true;

			let formData = new FormData(ev.target);

			/*let target : HTMLFormElement = ev.target;
			let inputs = target.querySelectorAll('input, select, textarea');
			for (let i=0; i<inputs.length; i++) {
				let input : HTMLInputElement = <HTMLInputElement> inputs.item(i);
				switch (input.tagName) {
					default:
						switch (input.getOrLoadAttribute('type')) {
							case 'checkbox':
								formData.append(input.name, input.checked ? '1' : '0');
								break;
							default:
								formData.append(input.name, input.value);
						}
				}
			}*/

			formData.append('ajax', '1');

			$scope.error = {
				Message: 'Checking...',
				MessageType: ''
			};

			$http.post('/Partial/AngularLoginForm', formData,{
						headers: {
							'Content-Type': undefined
						},
						transformRequest: angular.identity
					}
				)
				.then((result) => {
					if (result.data['code']) {
						console.log(result);
						return;
					}
					$scope.$close(result);
				})
				.catch((err) => {
					$scope.error = err.data;
					console.warn(err);
				})
				.finally(() => {
					$scope.pending = false;
				})
		}
	}
}
